import { DIRECTION_LEFT, DIRECTION_RIGHT } from 'webclient.constants';

export const SORTABLE_CARD = 'sortableCard';

export type SortResult = {
  sourceIndex: number;
  destinationIndex: number;
  direction: typeof DIRECTION_LEFT | typeof DIRECTION_RIGHT;
};

export type DragItem = {
  index: number;
  sourceIndex: number;
};
